import {useMutation} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";
import {captureDomainSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import {filesService} from "../services";

export function useCreateFiles() {
  const mutation = useMutation({
    mutationFn: filesService.create,
    onError: (error) => {
      captureDomainSubmitError(error, {feature: "platform", operation: "file_upload"});
      errorHandler(error);
    },
  });

  return mutation;
}
